import { GeneralInvokeOption } from 'src/types';
import {
  getRealRoute,
  encodeUrlQuery,
  checkUrl,
  logErrorAndRunFail
} from '../utils';
import MacleJSBridge from 'src/bridges';
import { APINames, CURRENT_ROUTE, getGlobal } from 'src/shared';

export interface RedirectToOption extends Partial<GeneralInvokeOption> {
  url: string;
}

/**
 * ```js
 *   ma.miniProgram.redirectTo({
 *     url: 'example?id=1',
 *     success: function(res) {},
 *     fail: function(res) {},
 *     complete: function(res) {},
 *   })
 * ```
 */
export function redirectTo(option: RedirectToOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.MiniProgram.REDIRECT_TO,
      option,
      'parameter error:parameter.url should be String instead of Undefined.'
    );
  }
  const redirectToOption = option;
  redirectToOption.url = getRealRoute(
    getGlobal(CURRENT_ROUTE) as string,
    redirectToOption.url
  );
  redirectToOption.url = encodeUrlQuery(redirectToOption.url);

  if (checkUrl(APINames.MiniProgram.REDIRECT_TO, redirectToOption)) {
    MacleJSBridge.beforeInvoke(
      APINames.MiniProgram.REDIRECT_TO,
      redirectToOption
    );
  }
}
